// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_whySection__w5tQg {
  background-color: var(--background-color0);
  padding: 6rem 0;
}

.styles_sectionTitle__jP6cM {
  font-size: 2.2rem;
  font-weight: 700;
  text-align: center;
  color: var(--text-color0);
  margin-bottom: 1rem;
}

.styles_divider__EwzWG {
  width: 5rem;
  height: 4px;
  background-color: var(--brand-yellow);
  border: none;
  border-radius: 2px;
  margin: 1.5rem auto 3.5rem auto;
}

.styles_cardsGrid__-vG8q {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2.5rem;
  margin-top: 2rem;
}

.styles_highlight__SYE21 {
  color: var(--brand-yellow);
}

@media (max-width: 900px) {
  .styles_cardsGrid__-vG8q {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
}

.styles_card__P8AQ3 {
  background: var(--background-color0);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 1rem;
  padding: 2.5rem 2rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.25rem;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
  position: relative;
}

.styles_card__P8AQ3:hover {
  transform: translateY(-8px);
  border-color: var(--brand-yellow);
  box-shadow: 0 12px 40px rgba(var(--brand-yellow-rgb), 0.15);
}

.styles_iconContainer__QJo99 {
  width: 4.5rem;
  height: 4.5rem;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(var(--brand-yellow-rgb), 0.1) 0%, rgba(var(--brand-yellow-rgb), 0.05) 100%);
  border: 2px solid var(--brand-yellow);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--brand-yellow);
  margin-bottom: 0.5rem;
}

.styles_cardTitle__yIStE {
  font-size: 1.4rem;
  font-weight: 700;
  color: var(--text-color0);
}

.styles_cardText__0823S {
  font-size: 1rem;
  color: var(--text-color1);
  line-height: 1.6;
}
`, "",{"version":3,"sources":["webpack://./src/pages/public/CadastroLoja/components/WhySection/styles.module.css"],"names":[],"mappings":"AAAA;EACE,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF;;AAEA;EACE,oCAAoC;EACpC,2CAA2C;EAC3C,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,0CAA0C;EAC1C,uDAAuD;EACvD,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,2DAA2D;AAC7D;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,oHAAoH;EACpH,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB","sourcesContent":[".whySection {\n  background-color: var(--background-color0);\n  padding: 6rem 0;\n}\n\n.sectionTitle {\n  font-size: 2.2rem;\n  font-weight: 700;\n  text-align: center;\n  color: var(--text-color0);\n  margin-bottom: 1rem;\n}\n\n.divider {\n  width: 5rem;\n  height: 4px;\n  background-color: var(--brand-yellow);\n  border: none;\n  border-radius: 2px;\n  margin: 1.5rem auto 3.5rem auto;\n}\n\n.cardsGrid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 2.5rem;\n  margin-top: 2rem;\n}\n\n.highlight {\n  color: var(--brand-yellow);\n}\n\n@media (max-width: 900px) {\n  .cardsGrid {\n    grid-template-columns: 1fr;\n    gap: 2rem;\n  }\n}\n\n.card {\n  background: var(--background-color0);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  border-radius: 1rem;\n  padding: 2.5rem 2rem;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1.25rem;\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);\n  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);\n  position: relative;\n}\n\n.card:hover {\n  transform: translateY(-8px);\n  border-color: var(--brand-yellow);\n  box-shadow: 0 12px 40px rgba(var(--brand-yellow-rgb), 0.15);\n}\n\n.iconContainer {\n  width: 4.5rem;\n  height: 4.5rem;\n  border-radius: 50%;\n  background: linear-gradient(135deg, rgba(var(--brand-yellow-rgb), 0.1) 0%, rgba(var(--brand-yellow-rgb), 0.05) 100%);\n  border: 2px solid var(--brand-yellow);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--brand-yellow);\n  margin-bottom: 0.5rem;\n}\n\n.cardTitle {\n  font-size: 1.4rem;\n  font-weight: 700;\n  color: var(--text-color0);\n}\n\n.cardText {\n  font-size: 1rem;\n  color: var(--text-color1);\n  line-height: 1.6;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"whySection": `styles_whySection__w5tQg`,
	"sectionTitle": `styles_sectionTitle__jP6cM`,
	"divider": `styles_divider__EwzWG`,
	"cardsGrid": `styles_cardsGrid__-vG8q`,
	"highlight": `styles_highlight__SYE21`,
	"card": `styles_card__P8AQ3`,
	"iconContainer": `styles_iconContainer__QJo99`,
	"cardTitle": `styles_cardTitle__yIStE`,
	"cardText": `styles_cardText__0823S`
};
export default ___CSS_LOADER_EXPORT___;
